(function(){
    angular
        .module('app')
        .directive('ngOnchange', onchange);

        onchange.$inject = ['$timeout'];
        function onchange($timeout){
            return {
            restrict:'A',
            replace: true,
            transclude: true,
            scope: { control : "=" },
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    console.log("E");
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("name");
                    scope.parentScope =  scope.control;
                    //console.log($attrs);
                    //console.log(name);
                    //console.log(scope.parentScope.camposActual[name]);
                    /*if(typeof scope.parentScope != 'undefined'){
                        $element.on('change', function() {
                            //console.log($element.val());
                            scope.$apply(function(){
                            	scope.parentScope.camposActual[name] = $element.val();
                            })
                        });
                    }*/
                    $element.on('change', function() {
                        //console.log($element.val());
                        scope.$apply(function(){
                            console.log($element.val());
                            ngModel.$setViewValue($element.val());
                        })
                    });
                });
            }
          }
      }
})();